<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="850px"
    center
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
      :disabled="mode === 'view'"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="平台名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入平台名称" maxlength="100" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理名称" prop="agent_name">
            <el-input v-model="form.agent_name" placeholder="请输入代理名称" maxlength="100" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所属机构" prop="channel_id">
            <el-select v-model="form.channel_id" placeholder="请选择所属机构" style="width: 100%">
              <el-option
                v-for="item in channelList"
                :key="item.id"
                :label="item.alias"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="App名称" prop="appname">
            <el-input v-model="form.appname" placeholder="请输入App名称" maxlength="100" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="App Key" prop="app_key">
            <el-input v-model="form.app_key" placeholder="请输入App Key" maxlength="100" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="disabled">
            <el-select v-model="form.disabled" placeholder="请选择状态" style="width: 100%">
              <el-option label="启用" :value="false" />
              <el-option label="禁用" :value="true" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="公司地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入公司地址" maxlength="500" />
      </el-form-item>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客服电话" prop="service_phone">
            <el-input v-model="form.service_phone" placeholder="请输入客服电话" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作人" prop="operator">
            <el-input v-model="form.operator" placeholder="请输入操作人" maxlength="50" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="安卓下载地址" prop="android_url">
        <el-input v-model="form.android_url" placeholder="请输入安卓下载地址" maxlength="500" />
      </el-form-item>
      
      <el-form-item label="iOS下载地址" prop="ios_url">
        <el-input v-model="form.ios_url" placeholder="请输入iOS下载地址" maxlength="500" />
      </el-form-item>
      
      <el-form-item label="H5地址" prop="h5_url">
        <el-input v-model="form.h5_url" placeholder="请输入H5地址" maxlength="500" />
      </el-form-item>
      
      <el-form-item label="Web地址" prop="web_url">
        <el-input v-model="form.web_url" placeholder="请输入Web地址" maxlength="500" />
      </el-form-item>
      
      <el-form-item label="备注" prop="note">
        <el-input
          v-model="form.note"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer" v-if="mode !== 'view'">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
    
    <div slot="footer" class="dialog-footer" v-else>
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveApp, getChannelList } from '@/api/custom-frontend'

export default {
  name: 'AppEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'add' // add, edit, view
    }
  },
  data() {
    return {
      dialogVisible: false,
      channelList: [],
      form: {
        id: null,
        name: '',
        agent_name: '',
        channel_id: '',
        appname: '',
        app_key: '',
        address: '',
        service_phone: '',
        operator: '',
        android_url: '',
        ios_url: '',
        h5_url: '',
        web_url: '',
        disabled: false,
        note: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入平台名称', trigger: 'blur' },
          { max: 100, message: '平台名称不能超过100个字符', trigger: 'blur' }
        ],
        agent_name: [
          { max: 100, message: '代理名称不能超过100个字符', trigger: 'blur' }
        ],
        channel_id: [
          { required: true, message: '请选择所属机构', trigger: 'change' }
        ],
        appname: [
          { required: true, message: '请输入App名称', trigger: 'blur' },
          { max: 100, message: 'App名称不能超过100个字符', trigger: 'blur' }
        ],
        app_key: [
          { required: true, message: '请输入App Key', trigger: 'blur' },
          { max: 100, message: 'App Key不能超过100个字符', trigger: 'blur' }
        ],
        disabled: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        address: [
          { max: 500, message: '公司地址不能超过500个字符', trigger: 'blur' }
        ],
        service_phone: [
          { max: 20, message: '客服电话不能超过20个字符', trigger: 'blur' }
        ],
        operator: [
          { max: 50, message: '操作人不能超过50个字符', trigger: 'blur' }
        ],
        android_url: [
          { max: 500, message: '安卓下载地址不能超过500个字符', trigger: 'blur' }
        ],
        ios_url: [
          { max: 500, message: 'iOS下载地址不能超过500个字符', trigger: 'blur' }
        ],
        h5_url: [
          { max: 500, message: 'H5地址不能超过500个字符', trigger: 'blur' }
        ],
        web_url: [
          { max: 500, message: 'Web地址不能超过500个字符', trigger: 'blur' }
        ],
        note: [
          { max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.getChannelList()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { ...val }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async getChannelList() {
      try {
        const res = await getChannelList()
        if (res && res.err_code === 0) {
          this.channelList = res.rows || []
        }
      } catch (error) {
        console.error('获取机构列表失败:', error)
      }
    },
    
    resetForm() {
      this.form = {
        id: null,
        name: '',
        agent_name: '',
        channel_id: '',
        appname: '',
        app_key: '',
        address: '',
        service_phone: '',
        operator: '',
        android_url: '',
        ios_url: '',
        h5_url: '',
        web_url: '',
        disabled: false,
        note: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    async handleSave() {
      if (this.mode === 'view') {
        this.handleClose()
        return
      }
      
      try {
        await this.$refs.form.validate()
        
        const data = { ...this.form }
        if (!data.id) {
          delete data.id
        }
        
        const res = await saveApp(data)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}
</style>